import {atom} from "recoil";
import {recoilPersist} from "recoil-persist";

const {persistAtom} = recoilPersist();

export const favoriList = atom({
    key: "favoriList",
    default: [],
    effects_UNSTABLE: [persistAtom],
});